export default __webpack_public_path__ + "static/instagram-96275a939a5f348fc8117da77b4d0d52.png";